
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Carpal_tunnel_syndrome',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Carpal_tunnel_syndrome.vue